import { Component } from '@theme/component';

class FellomiWithdrawal extends Component {
  #controller;

  connectedCallback() {
    super.connectedCallback();
    this.#initialize();
  }

  updatedCallback() {
    super.updatedCallback();
    this.#initialize();
  }

  disconnectedCallback() {
    this.#controller?.abort();
    super.disconnectedCallback();
  }

  #initialize() {
    this.#controller?.abort();
    const form = this.querySelector('#FellomiWithdrawal');
    const button = this.querySelector('#WithdrawalSubmit');
    if (!(form instanceof HTMLFormElement) || !(button instanceof HTMLButtonElement)) return;
    this.#controller = new AbortController();
    const options = { signal: this.#controller.signal };
    for (const event of ['input', 'change', 'submit']) form.addEventListener(event, this.prepare, options);
    this.prepare();
    button.disabled = false;
  }

  prepare = () => {
    const value = id => this.querySelector('#' + id)?.value.trim() ?? '';
    const items = this.querySelector('#WithdrawalItems');
    const scope = this.querySelector('#WithdrawalScope');
    const output = this.querySelector('#WithdrawalPayload');
    if (!(items instanceof HTMLTextAreaElement) || !(scope instanceof HTMLSelectElement) || !(output instanceof HTMLInputElement)) return;
    items.required = scope.selectedIndex === 1;
    const payload = { version: 1, name: value('WithdrawalName'), email: value('WithdrawalEmail'), contract: value('WithdrawalContract'), scope: scope.value, items: items.value.trim(), declaration: value('WithdrawalDeclaration') };
    const bytes = new TextEncoder().encode(JSON.stringify(payload));
    output.value = 'FELLOMI_DATA_START_' + btoa(Array.from(bytes, byte => String.fromCharCode(byte)).join('')) + '_FELLOMI_DATA_END';
  };
}

if (!customElements.get('fellomi-withdrawal-component')) customElements.define('fellomi-withdrawal-component', FellomiWithdrawal);
